import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e4b67fc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7e4b67fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b67fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4b67fc')) {
      api.createRecord('7e4b67fc', component.options)
    } else {
      api.reload('7e4b67fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e4b67fc&scoped=true&", function () {
      api.rerender('7e4b67fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/redPacket/index.vue"
export default component.exports